export const DEFAULT_APP_CONFIG = {
  SIGNER_PK:
    '-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHGiWP4kcFhu13uRAiamqpJIqj\nnvVT3cwD4U5kWnY5iAiZm1RJ8i3FLiVWtVkSHFyfr7emsjUJb+p3mcFkqYnXXtOj\n0oc64+iqMxg4B4cuOL3aAkshLk9S32lT5xz1m+uP1yzz6RfcmrIyo0ZFrA7UXL8a\nopJoca1BL6Sz3M7WFQIDAQAB\n-----END PUBLIC KEY-----',
};
